import { generateKeys, generateLocalization } from '../utils';
import { countries } from './countries';
import { fundingCategories } from './documents';
const vanuatuBankTransferInfo = {
    EUR: {
        recipient: 'BDS LTD',
        iban: 'CY75904000010003500092501000',
        swift: 'ISEMCY22',
        bank: 'iSignthis eMoney Ltd',
        address: 'Makrasykas 1, KBC North, Strovolos, 2034',
        city: 'Nicosia',
        country: 'Cyprus',
        currency: 'EUR',
        creditingAccount: '3500092501000',
    },
    GBP: {
        recipient: 'BDS LTD',
        iban: 'CY75904000010003500092501000',
        swift: 'ISEMCY22',
        bank: 'iSignthis eMoney Ltd',
        address: 'Makrasykas 1, KBC North, Strovolos, 2034',
        city: 'Nicosia',
        country: 'Cyprus',
        currency: 'EUR',
        creditingAccount: '3500092501000',
    },
    USD: {
        recipient: 'BDS LTD',
        iban: 'GB56COUT18009106621473',
        swift: 'COUTGB22',
        bank: 'Coutts and Co.',
        address: '440 Strand, WC2R 0QS',
        city: 'London',
        country: 'United Kingdom',
        currency: 'USD',
        creditingAccount: '06621473',
    },
};
const mauritiusBankTransferInfo = {
    GBP: {
        recipient: 'BDS Markets',
        iban: 'GB68COUT18000207596235',
        swift: 'COUTGB22',
        bank: 'Coutts and Co.',
        address: '440 Strand, London, WC2R 0QS',
        city: 'London',
        country: 'United Kingdom',
        currency: 'GBP',
        creditingAccount: '07596235',
    },
    EUR: {
        recipient: 'BDS Markets',
        iban: 'GB95COUT18009103596214',
        swift: 'COUTGB22',
        bank: 'Coutts and Co.',
        address: '440 Strand, London, WC2R 0QS',
        city: 'London',
        country: 'United Kingdom',
        currency: 'EUR',
        creditingAccount: '03596214',
    },
    USD: {
        recipient: 'BDS Markets',
        iban: 'MU69STCB1170000000055767000USD',
        swift: 'STCBMUMU',
        bank: 'SBM Bank (Mauritius) Ltd',
        address: '9th Floor SBM Tower',
        city: 'Port Louis',
        country: 'Mauritius',
        currency: 'USD',
        creditingAccount: '50100000055767',
    },
};
const countrybankTransferInfo = {
    recipient: 'Monsas Ltd',
    iban: 'GB34 COUT 1800 9104 5962 18',
    swift: 'COUTGB22',
    bank: 'Coutts and Co.',
    address: '440 Strand, London, WC2R 0QS',
    city: 'London',
    country: 'United Kingdom',
    currency: 'USD',
    creditingAccount: '04596218',
};
export const countryBankTransfer = {
    TW: {
        info: countrybankTransferInfo,
    },
    CN: {
        info: countrybankTransferInfo,
    },
    HK: {
        info: countrybankTransferInfo,
    },
};
export const bankTransferInfo = {
    USD: {
        default: {
            recipient: 'BDSwiss Holding PLC – Clients Accounts',
            iban: 'CY95008001700000000001817171',
            swift: 'PIRBCY2NXXX',
            bank: 'Astro Bank',
            address: '1 Spyrou Kyprianou Avenue',
            city: '1065 Nicosia',
            country: 'Cyprus',
            currency: 'USD',
            creditingAccount: '0001817171',
        },
        bdSwissMauritius: mauritiusBankTransferInfo.USD,
        bdSwissVanuatu: vanuatuBankTransferInfo.USD,
        swissMarketsMauritius: mauritiusBankTransferInfo.USD,
        swissMarketsVanuatu: vanuatuBankTransferInfo.USD,
    },
    EUR: {
        default: {
            recipient: 'BDSwiss Holding PLC',
            iban: 'CY36008001700000000001817166',
            swift: 'PIRBCY2NXXX',
            bank: 'Astro Bank',
            address: '1 Spyrou Kyprianou Avenue',
            city: '1065 Nicosia',
            country: 'Cyprus',
            currency: 'EUR',
            creditingAccount: '0001817166',
        },
        bdSwissMauritius: mauritiusBankTransferInfo.EUR,
        bdSwissVanuatu: vanuatuBankTransferInfo.EUR,
        swissMarketsMauritius: mauritiusBankTransferInfo.EUR,
        swissMarketsVanuatu: vanuatuBankTransferInfo.EUR,
    },
    GBP: {
        default: {
            recipient: 'BDSwiss Holding PLC – Clients Accounts',
            iban: 'CY51008001700000000001817187',
            swift: 'PIRBCY2NXXX',
            bank: 'Astro Bank',
            address: '1 Spyrou Kyprianou Avenue',
            city: '1065 Nicosia',
            country: 'Cyprus',
            currency: 'GBP',
            creditingAccount: '0001817187',
        },
        bdSwissMauritius: mauritiusBankTransferInfo.GBP,
        bdSwissVanuatu: vanuatuBankTransferInfo.GBP,
        swissMarketsMauritius: mauritiusBankTransferInfo.GBP,
        swissMarketsVanuatu: mauritiusBankTransferInfo.GBP,
    },
    CHF: {
        default: {
            recipient: 'BDSwiss Holding PLC',
            iban: 'CY36008001700000000001817166',
            swift: 'PIRBCY2NXXX',
            bank: 'Astro Bank',
            address: '1 Spyrou Kyprianou Avenue',
            city: '1065 Nicosia',
            country: 'Cyprus',
            currency: 'EUR',
            creditingAccount: '0001817166',
        },
        bdSwissMauritius: mauritiusBankTransferInfo.EUR,
        bdSwissVanuatu: vanuatuBankTransferInfo.EUR,
        swissMarketsMauritius: mauritiusBankTransferInfo.EUR,
        swissMarketsVanuatu: vanuatuBankTransferInfo.EUR,
    },
    PLN: {
        default: {
            recipient: 'BDSwiss Holding PLC',
            iban: 'CY36008001700000000001817166',
            swift: 'PIRBCY2NXXX',
            bank: 'Astro Bank',
            address: '1 Spyrou Kyprianou Avenue',
            city: '1065 Nicosia',
            country: 'Cyprus',
            currency: 'EUR',
            creditingAccount: '0001817166',
        },
        bdSwissMauritius: mauritiusBankTransferInfo.EUR,
        bdSwissVanuatu: vanuatuBankTransferInfo.EUR,
        swissMarketsMauritius: mauritiusBankTransferInfo.EUR,
        swissMarketsVanuatu: vanuatuBankTransferInfo.EUR,
    },
    DKK: {
        default: {
            recipient: 'BDSwiss Holding PLC',
            iban: 'CY36008001700000000001817166',
            swift: 'PIRBCY2NXXX',
            bank: 'Astro Bank',
            address: '1 Spyrou Kyprianou Avenue',
            city: '1065 Nicosia',
            country: 'Cyprus',
            currency: 'EUR',
            creditingAccount: '0001817166',
        },
        bdSwissMauritius: mauritiusBankTransferInfo.EUR,
        bdSwissVanuatu: vanuatuBankTransferInfo.EUR,
        swissMarketsMauritius: mauritiusBankTransferInfo.EUR,
        swissMarketsVanuatu: vanuatuBankTransferInfo.EUR,
    },
    SEK: {
        default: {
            recipient: 'BDSwiss Holding PLC',
            iban: 'CY36008001700000000001817166',
            swift: 'PIRBCY2NXXX',
            bank: 'Astro Bank',
            address: '1 Spyrou Kyprianou Avenue',
            city: '1065 Nicosia',
            country: 'Cyprus',
            currency: 'EUR',
            creditingAccount: '0001817166',
        },
        bdSwissMauritius: mauritiusBankTransferInfo.EUR,
        bdSwissVanuatu: vanuatuBankTransferInfo.EUR,
        swissMarketsMauritius: mauritiusBankTransferInfo.EUR,
        swissMarketsVanuatu: vanuatuBankTransferInfo.EUR,
    },
    NOK: {
        default: {
            recipient: 'BDSwiss Holding PLC',
            iban: 'CY36008001700000000001817166',
            swift: 'PIRBCY2NXXX',
            bank: 'Astro Bank',
            address: '1 Spyrou Kyprianou Avenue',
            city: '1065 Nicosia',
            country: 'Cyprus',
            currency: 'EUR',
            creditingAccount: '0001817166',
        },
        bdSwissMauritius: mauritiusBankTransferInfo.EUR,
        bdSwissVanuatu: vanuatuBankTransferInfo.EUR,
        swissMarketsMauritius: mauritiusBankTransferInfo.EUR,
        swissMarketsVanuatu: vanuatuBankTransferInfo.EUR,
    },
};
export const kalixaPaymentTypes = generateKeys({
    netpay: {
        value: 'EPS ERSTE -  NETPAY deposit',
        label: 'Netpay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    visa: {
        value: 'VISA Deposit',
        label: 'Visa',
        kalixaKeys: {
            deposit: 2,
            refund: 88,
        },
        fundingCategory: fundingCategories.card.value,
    },
    ecmc: {
        value: 'ECMC Deposit',
        label: 'ECMC',
        kalixaKeys: {
            deposit: 1,
            refund: 89,
        },
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    ecmcDebit: {
        value: 'ECMC Debit Deposit',
        label: 'ECMC Debit',
        kalixaKeys: {
            deposit: 168,
            refund: 89,
        },
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    epspop: {
        value: 'EPS BAC - POP deposit',
        label: 'EPS POP',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    elba: {
        value: 'EPS Raiffeisen -  ELBA deposit',
        label: 'ELBA',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    neteller: {
        value: 'NETeller Deposit',
        label: 'neteller',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    epseasybank: {
        value: 'EPSEasyBankDeposit',
        label: 'EPSEasyBank',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    postpay: {
        value: 'PostePayDeposit',
        label: 'PostePayDeposit',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    visadeb: {
        value: 'VISA Debit Deposit',
        label: 'Visa Debit',
        kalixaKeys: {
            deposit: 167,
            refund: 88,
        },
        fundingCategory: fundingCategories.card.value,
    },
    directebanking: {
        value: 'DirectEBankingDeposit',
        label: 'DirectEbanking',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    mastercard: {
        label: 'Mastercard',
        value: 'MASTERCARD Deposit',
        key: 'Mastercard',
        fundingCategory: fundingCategories.card.value,
    },
    giropay: {
        value: 'GiropayDeposit',
        label: 'Giropay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    maestro: {
        value: 'MAESTRO Deposit',
        label: 'Maestro',
        kalixaKeys: {
            deposit: 73,
            refund: 90,
        },
        fundingCategory: fundingCategories.card.value,
    },
    sofort: {
        value: 'Sofort Deposit',
        label: 'Sofort',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    ukash: {
        value: 'Ukash Deposit',
        label: 'Ukash',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    paysafecard: {
        value: 'Paysafecard Deposit',
        label: 'Paysafecard',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    paysafecarddirect: {
        value: 'PaysafecardDirectDeposit',
        label: 'Paysafecard DirectDeposit',
        fundingCategory: fundingCategories.card.value,
    },
    epsbawag: {
        value: 'EPS BAWAG - DirectPay deposit',
        label: 'EPS BAWAG',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    americanExpress: {
        value: 'AMEXDeposit',
        label: 'American Express',
        kalixaKeys: {
            deposit: 113,
            refund: 115,
        },
        fundingCategory: fundingCategories.card.value,
    },
    diners: {
        value: 'Diners Deposit',
        label: 'Diners',
        kalixaKeys: {
            deposit: 3,
            refund: 154,
        },
        fundingCategory: fundingCategories.card.value,
    },
});
export const wirecardPaymentTypes = generateKeys({
    mastercard: {
        value: 'mastercard',
        label: 'Mastercard',
    },
    diners: {
        value: 'diners',
        label: 'Diners',
    },
    visa: {
        value: 'visa',
        label: 'Visa',
    },
    master: {
        value: 'master',
        label: 'Mastercard',
    },
    americanExpress: {
        value: 'american_express',
        label: 'American Express',
    },
    discover: {
        value: 'discover',
        label: 'Discover',
    },
    dinersClub: {
        value: 'diners_club',
        label: 'Diners',
    },
    jcb: {
        value: 'jcb',
        label: 'JCB',
    },
    maestro: {
        value: 'maestro',
        label: 'Maestro',
    },
});
export const dlocalTransactionResults = generateKeys({
    completed: {
        value: '9',
        label: 'Amount Paid. Transaction successfully concluded',
    },
    rejected: {
        value: '8',
        label: 'Operation rejected by the bank',
    },
    pending: {
        value: '7',
        label: 'Pending transaction awaiting approval',
    },
    cancelled: {
        value: '6',
        label: 'Transaction not found in the system',
    },
});
export const dotpayTransactionResults = generateKeys({
    new: {},
    processing: {},
    completed: {},
    rejected: {},
    processing_realization_waiting: {},
    processing_realization: {},
});
export const zotapayTransactionStatuses = generateKeys({
    approved: {},
    declined: {},
    error: {},
    filtered: {},
    processing: {},
    unknown: {},
});
export const zotapayTransactionErrorTypes = generateKeys({
    error: {
        value: 'error',
    },
    validationError: {
        value: 'validation-error',
    },
});
export const zotapayPaymentOptionsCNY = generateKeys({
    cup: {
        label: 'CUP',
    },
    weChat: {
        label: 'WeChat',
        disabled: true,
    },
    alipay: {
        label: 'Alipay',
        disabled: true,
    },
    qq: {
        label: 'QQ',
    },
});
export const zotapayBanks = generateKeys({
    bbl: {
        value: 'BBL',
        label: 'Bangkok Bank',
        country: countries.th,
    },
    gsb: {
        value: 'GSB',
        label: 'Government Savings Bank',
        country: countries.th,
    },
    ktb: {
        value: 'KTB',
        label: 'KTB Net Bank',
        country: countries.th,
    },
    cimbt: {
        value: 'CIMBT',
        label: 'CIMB Thai',
        country: countries.th,
    },
    tmb: {
        value: 'TMB',
        label: 'TMB Bank Public Company Limited',
        country: countries.th,
    },
    boa: {
        value: 'BOA',
        label: 'Bank of Ayudhya',
        country: countries.th,
    },
    kkr: {
        value: 'KKR',
        label: 'KasiKorn Bank',
        country: countries.th,
    },
    scb: {
        value: 'SCB',
        label: 'Siam Commercial Bank',
        country: countries.th,
    },
    knk: {
        value: 'KNK',
        label: 'Kiatnakin Bank',
        country: countries.th,
    },
    acb: {
        value: 'ACB',
        label: 'Asia Commercial Bank',
        country: countries.vn,
    },
    sacom: {
        value: 'SACOM',
        label: 'Sacom Bank',
        country: countries.vn,
    },
    vcb: {
        value: 'VCB',
        label: 'Vietcom Bank',
        country: countries.vn,
    },
    exim: {
        value: 'EXIM',
        label: 'Eximbank Vietnam',
        country: countries.vn,
    },
    scmb: {
        value: 'SCMB',
        label: 'SAIGON Bank',
        country: countries.vn,
    },
    agb: {
        value: 'AGB',
        label: 'Agribank',
        country: countries.vn,
    },
    dab: {
        value: 'DAB',
        label: 'DongA Joint Stock Commercial Bank',
        country: countries.vn,
    },
    tcb: {
        value: 'TCB',
        label: 'Techcom Bank',
        country: countries.vn,
    },
    vtb: {
        value: 'VTB',
        label: 'VietinBank',
        country: countries.vn,
    },
    bidv: {
        value: 'BIDV',
        label: 'Bank for Investment and Development of Vietnam',
        country: countries.vn,
    },
    vib: {
        value: 'VIB',
        label: 'Vietnam International Bank',
        country: countries.vn,
    },
    aff: {
        value: 'AFF',
        label: 'Affin Bank',
        country: countries.my,
    },
    amb: {
        value: 'AMB',
        label: 'AM Bank',
        country: countries.my,
    },
    bsn: {
        value: 'BSN',
        label: 'Bank Simpanan National',
        country: countries.my,
    },
    citi: {
        value: 'CITI',
        label: 'CITI Bank',
        country: countries.my,
    },
    hsbc: {
        value: 'HSBC',
        label: 'HSBC Bank',
        country: countries.my,
    },
    ocbc: {
        value: 'OCBC',
        label: 'OCBC Bank',
        country: countries.my,
    },
    rhb: {
        value: 'RHB',
        label: 'RHB Bank',
        country: countries.my,
    },
    sctb: {
        value: 'SCTB',
        label: 'Standard Chartered Bank',
        country: countries.my,
    },
    alb: {
        value: 'ALB',
        label: 'Alliance Bank',
        country: countries.my,
    },
    bimb: {
        value: 'BIMB',
        label: 'Bank Islam Malaysia',
        country: countries.my,
    },
    cimb: {
        value: 'CIMB',
        label: 'CIMB Bank',
        country: countries.my,
    },
    hlb: {
        value: 'HLB',
        label: 'Hong Leong Bank',
        country: countries.my,
    },
    mbb: {
        value: 'MBB',
        label: 'Maybank',
        country: countries.my,
    },
    pbb: {
        value: 'PBB',
        label: 'Public Bank',
        country: countries.my,
    },
    uob: {
        value: 'UOB',
        label: 'UOB Bank',
        country: countries.my,
    },
    bca: {
        value: 'BCA',
        label: 'Bank Central Asia',
        country: countries.id,
    },
    mdr: {
        value: 'MDR',
        label: 'Bank Mandiri',
        country: countries.id,
    },
    cimbn: {
        value: 'CIMBN',
        label: 'CIMB Niaga',
        country: countries.id,
    },
    bni: {
        value: 'BNI',
        label: 'Bank Negara Indonesia',
        country: countries.id,
    },
    bri: {
        value: 'BRI',
        label: 'Bank Rakyat Indonesia',
        country: countries.id,
    },
    pmtb: {
        value: 'PMTB',
        label: 'Permata Bank',
        country: countries.id,
    },
    abc: {
        value: 'ABC',
        label: 'Agricultural Bank of China',
        country: countries.cn,
    },
    bob: {
        value: 'BOB',
        label: 'Bank of Beijing',
        country: countries.cn,
    },
    boc: {
        value: 'BOC',
        label: 'Bank of China',
        country: countries.cn,
    },
    bod: {
        value: 'BOD',
        label: 'Bank of Dongguan',
        country: countries.cn,
    },
    bos: {
        value: 'BOS',
        label: 'Bank of Shanghai',
        country: countries.cn,
    },
    cbhb: {
        value: 'CBHB',
        label: 'China BoHai Bank',
        country: countries.cn,
    },
    ccb: {
        value: 'CCB',
        label: 'China Construction Bank',
        country: countries.cn,
    },
    ceb: {
        value: 'CEB',
        label: 'China Everbright Bank',
        country: countries.cn,
    },
    cib: {
        value: 'CIB',
        label: 'China Industrial Bank',
        country: countries.cn,
    },
    citic: {
        value: 'CITIC',
        label: 'China Citic Bank',
        country: countries.cn,
    },
    cmb: {
        value: 'CMB',
        label: 'China Merchants Bank',
        country: countries.cn,
    },
    cmbc: {
        value: 'CMBC',
        label: 'China Minsheng Bank',
        country: countries.cn,
    },
    comm: {
        value: 'COMM',
        label: 'Bank Of Communications',
        country: countries.cn,
    },
    czb: {
        value: 'CZB',
        label: 'China Zheshang Bank',
        country: countries.cn,
    },
    gdb: {
        value: 'GDB',
        label: 'Guandong Development Bank',
        country: countries.cn,
    },
    gzb: {
        value: 'GZB',
        label: 'Bank of Guangzhou',
        country: countries.cn,
    },
    hxb: {
        value: 'HXB',
        label: 'HuaXia Bank',
        country: countries.cn,
    },
    hzb: {
        value: 'HZB',
        label: 'Bank Of HangZhou',
        country: countries.cn,
    },
    icbc: {
        value: 'ICBC',
        label: 'Industrial and Commercial Bank of China',
        country: countries.cn,
    },
    pab: {
        value: 'PAB',
        label: 'Ping An Bank',
        country: countries.cn,
    },
    psbc: {
        value: 'PSBC',
        label: 'Postal Savings Bank Of China',
        country: countries.cn,
    },
    sdb: {
        value: 'SDB',
        label: 'Shenzhen Develop Bank',
        country: countries.cn,
    },
    spdb: {
        value: 'SPDB',
        label: 'Shanghai Pudong Development Bank',
        country: countries.cn,
    },
    hkb: {
        value: 'HKB',
        label: 'HanKou Bank',
        country: countries.cn,
    },
    nbb: {
        value: 'NBB',
        label: 'Bank of Ningbo',
        country: countries.cn,
    },
    bocd: {
        value: 'BOCD',
        label: 'Bank of Chengdu',
        country: countries.cn,
    },
});
export const paytrustTransactionStatuses = generateKeys({
    initiated: {
        value: 0,
        label: 'Initiated',
    },
    accepted: {
        value: 1,
        label: 'Accepted',
    },
    rejected: {
        value: -1,
        label: 'Rejected',
    },
    error: {
        value: -2,
        label: 'Error',
    },
    pending: {
        value: -3,
        label: 'Pending',
    },
});
export const paytrustPayoutStatuses = generateKeys({
    requested: {
        value: 0,
        label: 'Requested',
    },
    authorized: {
        value: 1,
        label: 'Authorized',
    },
    rejected: {
        value: -1,
        label: 'Rejected',
    },
    paid: {
        value: 2,
        label: 'Paid',
    },
    confirmed: {
        value: 3,
        label: 'Confirmed',
    },
    invalid: {
        value: -3,
        label: 'Invalid',
    },
    cancelled: {
        value: -2,
        label: 'Cancelled',
    },
});
export const paytrustTransactionErrorTypes = generateKeys({
    error: {
        value: 'error',
    },
    validationError: {
        value: 'validation-error',
    },
});
export const payCVPaymentOptions = generateKeys({
    alipay: {
        label: 'Alipay',
    },
    creditcard: {
        label: 'Credit Card',
    },
    icbc: {
        label: 'Industrial and Commercial of China',
    },
    ccb: {
        label: 'China Construction Bank',
    },
    spdb: {
        label: 'Shanghai Pudong Development Bank',
    },
    abc: {
        label: 'Agricultural Bank of China',
    },
    bcom: {
        label: 'Bank of Communications',
    },
    cebb: {
        label: 'Everbright Bank',
    },
    boc: {
        label: 'The Bank of China',
    },
    spabank: {
        label: 'Ping an Bank',
    },
    gdb: {
        label: 'Guangdong Development Bank',
    },
    ecitic: {
        label: 'China Citic Bank',
    },
    nbcb: {
        label: 'Ningbo Bank',
    },
    psbc: {
        label: 'China Post Bank',
    },
    hxb: {
        label: 'Huaxia Bank',
    },
    bos: {
        label: 'Shanghai Bank',
    },
    bob: {
        label: 'Bank of Beijing',
    },
});
export const cryptoPaymentOptions = generateKeys({
    BTC: {
        value: 'bitcoin',
        label: 'BTC',
        fundingCategory: fundingCategories.crypto.value,
    },
    ETH: {
        value: 'ethereum',
        label: 'ETH',
        fundingCategory: fundingCategories.crypto.value,
    },
    BCH: {
        value: 'bitcoin-cash',
        label: 'BCH',
        fundingCategory: fundingCategories.crypto.value,
    },
});
export const funtopayCardOptions = generateLocalization('funtopayCardOptions', generateKeys({
    debit: {
        value: '01',
        label: 'Debit Card',
        localization: { id: '', defaultMessage: '' },
    },
    credit: {
        value: '02',
        label: 'Credit Card',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const paytrustPaymentOptions = generateKeys({
    hongLeong: {
        label: 'Hong Leong',
        value: '59f413ca94c67',
        country: 'my',
    },
    maybank: {
        label: 'Maybank',
        value: '59f413e3ac31f',
        country: 'my',
    },
    cimb: {
        label: 'CIMB',
        value: '59f413f699727',
        country: 'my',
    },
    publicBank: {
        label: 'Public Bank',
        value: '59f414215b156',
        country: 'my',
    },
    rhb: {
        label: 'RHB',
        value: '5b3558e1ad70d',
        country: 'my',
    },
    bankBni: {
        label: 'Bank BNI',
        value: '59f414a0180a8',
        country: 'id',
    },
    bankBca: {
        label: 'Bank BCA',
        value: '59f4149441ddc',
        country: 'id',
    },
    bankBri: {
        label: 'Bank BRI',
        value: '59f414875bddc',
        country: 'id',
    },
    bankMandiri: {
        label: 'Bank Mandiri',
        value: '59f4147ae7d6f',
        country: 'id',
    },
    kasikornBank: {
        label: 'Kasikorn Bank',
        value: '59f414091aeb1',
        country: 'th',
    },
    bangkokBank: {
        label: 'Bangkok Bank',
        value: '59f4143921ba5',
        country: 'th',
    },
    ktbNetBank: {
        label: 'KTB NetBank',
        value: '59f414434c28e',
        country: 'th',
    },
    scbEasy: {
        label: 'SCB Easy',
        value: '59f414509ca5d',
        country: 'th',
    },
    vietin: {
        label: 'Vietin',
        value: '5a8d9b3432bc7',
        country: 'vn',
    },
    vietCom: {
        label: 'VietCom',
        value: '5a8dbfef271b0',
        country: 'vn',
    },
    techComBank: {
        label: 'TechCom Bank',
        value: '5a8ee643945a3',
        country: 'vn',
    },
    dongaBank: {
        label: 'DongaBank',
        value: '5a904bc3775ba',
        country: 'vn',
    },
    acb: {
        label: 'ACB',
        value: '5a900eca03af6',
        country: 'vn',
    },
});
export const skrillPaymentTypes = generateKeys({
    skrillWallet: {
        value: 'WLT',
        label: 'Skrill Digital Wallet',
    },
    neteller: {
        value: 'NTL',
        label: 'Neteller',
    },
    paysafeCard: {
        value: 'PSC',
        label: 'Paysafecard',
    },
    paysafeCash: {
        value: 'PCH',
        label: 'Paysafecash',
    },
    resurs: {
        value: 'RSB',
        label: 'Resurs',
    },
    allCards: {
        value: 'ACC',
        label: 'All Card Types',
    },
    visa: {
        value: 'VSA',
        label: 'Visa',
    },
    masterCard: {
        value: 'MSC',
        label: 'MasterCard',
    },
    visaDebit: {
        value: 'VSD',
        label: 'Visa Delta/Debit',
    },
    visaElectron: {
        value: 'VSE',
        label: 'Visa Electron',
    },
    maestro: {
        value: 'MAE',
        label: 'Maestro',
    },
    americanExpress: {
        value: 'AMX',
        label: 'American Express',
    },
    diners: {
        value: 'DIN',
        label: 'Diners',
    },
    jcb: {
        value: 'JCB',
        label: 'JCB',
    },
    carteBleue: {
        value: 'GCB',
        label: 'Carte Bleue',
    },
    dankort: {
        value: 'DNK',
        label: 'Dankort',
    },
    postePay: {
        value: 'PSP',
        label: 'PostePay',
    },
    cartaSi: {
        value: 'CSI',
        label: 'CartaSi',
    },
    rapidTransfer: {
        value: 'OBT',
        label: 'Online Bank Transfer',
    },
    rapidTransferAlternative: {
        value: 'NGP',
        label: 'Online Bank Transfer',
    },
    giropay: {
        value: 'GIR',
        label: 'Giropay',
    },
    directDebit: {
        value: 'DID',
        label: 'Direct Debit / SEPA',
    },
    klarna: {
        value: 'SFT',
        label: 'Klarna',
    },
    nordeaSolo: {
        value: 'EBT',
        label: 'Nordea Solo',
    },
    ideal: {
        value: 'IDL',
        label: 'iDEAL',
    },
    eps: {
        value: 'NPY',
        label: 'EPS (Netpay)',
    },
    poli: {
        value: 'PLI',
        label: 'POLi',
    },
    przelewy: {
        value: 'PWY',
        label: 'Przelewy24',
    },
    epay: {
        value: 'EPY',
        label: 'ePay.bg',
    },
    trustly: {
        value: 'GLU',
        label: 'Trustly',
    },
    alipay: {
        value: 'ALI',
        label: 'Alipay',
    },
    astropayOnlineBankTransfer: {
        value: 'ADB',
        label: 'Astropay - Online bank transfer',
    },
    astropayOfflineBankTransfer: {
        value: 'AOB',
        label: 'Astropay - Offline bank transfer',
    },
    astropayCash: {
        value: 'ACI',
        label: 'Astropay - Cash (Invoice)',
    },
    unionpay: {
        value: 'AUP',
        label: 'Unionpay',
    },
});
export const payzoffPaymentOptions = generateKeys({
    creditCard: {
        value: 'creditCard',
        label: 'Credit Card',
        code: 1001,
        fundingCategory: fundingCategories.card.value,
    },
    eps: {
        value: 'eps',
        label: 'EPS',
        code: 1082,
        fields: ['accountholdername'],
        fundingCategory: fundingCategories.card.value,
    },
    p24: {
        value: 'p24',
        label: 'P24 Payout',
        code: 1581,
        refundDisabled: true,
        fields: ['iban', 'accountholdername'],
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    sepa: {
        value: 'sepa',
        label: 'SEPA Payout',
        code: 1580,
        refundDisabled: true,
        fields: ['iban', 'accountholdername'],
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    sofort: {
        value: 'sofort',
        label: 'Sofort',
        code: 1076,
        fields: ['iban', 'bic', 'accountholdername'],
        fundingCategory: fundingCategories.onlineBanking.value,
    },
});
export const safechargePaymentTypes = generateKeys({
    creditCard: {
        value: 'cc_card',
        label: 'Credit Card',
        fundingCategory: fundingCategories.card.value,
    },
    sofort: {
        value: 'apmgw_Sofort',
        label: 'Sofort',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    iDeal: {
        value: 'apmgw_iDeal',
        label: 'iDeal',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    giropay: {
        value: 'apmgw_Giropay',
        label: 'Giropay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    webMoney: {
        value: 'apmgw_Webmoney_SMS_Invoice_',
        label: 'Web Money',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    neosurf: {
        value: 'apmgw_Neosurf',
        label: 'Neosurf',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    astroPay: {
        value: 'apmgw_AstroPay',
        label: 'AstroPay Sc',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    boleto: {
        value: 'apmgw_BOLETO',
        label: 'Boleto',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    todito: {
        value: 'apmgw_Todito_Cash',
        label: 'Todito Cash',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    eps: {
        value: 'apmgw_EPS',
        label: 'EPS',
        fundingCategory: fundingCategories.card.value,
    },
    banContact: {
        value: 'apmgw_BanContact',
        label: 'BanContact',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    epayBg: {
        value: 'apmgw_Epay_bg',
        label: 'Epay.bg',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    euteller: {
        value: 'apmgw_Euteller',
        label: 'Euteller',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    multibanco: {
        value: 'apmgw_MULTIBANCO',
        label: 'MULTIBANCO',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    p24: {
        value: 'apmgw_P24',
        label: 'Przelewy24',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    qiwi: {
        value: 'apmgw_QIWI',
        label: 'QIWI',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    safetypay: {
        value: 'apmgw_Safetypay',
        label: 'Safetypay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    trustpay: {
        value: 'apmgw_Trustpay',
        label: 'Trustpay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    onlineBanking: {
        value: 'apmgw_2C2P_APMs',
        label: '2C2P',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    trustly: {
        value: 'apmgw_Trustly_DI',
        label: 'Trustly',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    paysafecard: {
        value: 'apmgw_PaySafeCard',
        label: 'PaySafeCard',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    sepa: {
        value: 'apmgw_SEPA_Payouts',
        label: 'SEPA',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    upi: {
        value: 'apmgw_UPI',
        label: 'UPI',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    netbanking: {
        value: 'apmgw_Netbanking_TW',
        label: 'Netbanking',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    openBanking: {
        value: 'apmgw_Open_Banking',
        label: 'Open Banking',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    instantOpenBanking: {
        value: 'apmgw_Instant_Open_Banking',
        label: 'Instant Open Banking',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    interac: {
        value: 'apmgw_Interac_Combined',
        label: 'INTERAC e-Transfer',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    googlepay: {
        value: 'googlepay',
        label: 'GooglePay',
        fundingCategory: fundingCategories.card.value,
    },
    applepay: {
        value: 'applepay',
        label: 'ApplePay',
        fundingCategory: fundingCategories.card.value,
    },
});
export const easyeftTransactionStatuses = generateKeys({
    complete: {
        value: 'Complete',
        label: 'Complete',
    },
    cancelled: {
        value: 'Cancelled',
        label: 'Cancelled',
    },
    error: {
        value: 'Error',
        label: 'Error',
    },
    abandoned: {
        value: 'Abandoned',
        label: 'Abandoned',
    },
    investigation: {
        value: 'PendingInvestigation',
        label: 'PendingInvestigation',
    },
    pending: {
        value: 'Pending',
        label: 'Pending',
    },
});
export const nganLuongPaymentMethods = generateKeys({
    nl: {
        value: 'NL',
        label: 'E-wallet',
        fundingCategory: fundingCategories.eWallet.value,
    },
    visa: {
        value: 'VISA',
        label: 'Credit/Debit Card',
        fundingCategory: fundingCategories.card.value,
    },
    atmOnline: {
        value: 'ATM_ONLINE',
        label: 'ATM Online',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    atmOffline: {
        value: 'ATM_OFFLINE',
        label: 'ATM Offline',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    nhOffline: {
        value: 'NH_OFFLINE',
        label: 'Bank Counter Offline',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    ibOnline: {
        value: 'IB_ONLINE',
        label: 'Internet Banking Online',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    qrCode: {
        value: 'QRCODE',
        label: 'QR Code',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
});
export const nganLuongBankCodeOptions = generateKeys({
    vcb: {
        value: 'VCB',
        label: 'JSC Bank for Foreign Trade of Vietnam (Vietcombank )',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.atmOffline.value,
            nganLuongPaymentMethods.ibOnline.value,
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    dab: {
        value: 'DAB',
        label: 'DongA JSC Bank (DongA Bank)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.atmOffline.value,
            nganLuongPaymentMethods.ibOnline.value,
        ],
    },
    tcb: {
        value: 'TCB',
        label: 'The Vietnam Technological and Commercial JSC Bank (Techcombank )',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.atmOffline.value,
            nganLuongPaymentMethods.ibOnline.value,
        ],
    },
    mb: {
        value: 'MB',
        label: 'Military JSC Bank (MB)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.atmOffline.value,
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    vib: {
        value: 'VIB',
        label: 'Vietnam International Bank (VIB)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
        ],
    },
    icb: {
        value: 'ICB',
        label: 'Vietnam Joint Stock Commercial Bank for Industry and Trade (VietinBank)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.atmOffline.value,
            nganLuongPaymentMethods.ibOnline.value,
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    exb: {
        value: 'EXB',
        label: 'Vietnam Export Import Commercial Joint Stock Bank (Eximbank)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.ibOnline.value,
        ],
    },
    acb: {
        value: 'ACB',
        label: 'Asia Commercial Bank (ACB)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.atmOffline.value,
        ],
    },
    hdb: {
        value: 'HDB',
        label: 'HoChiMinh City Development Joint Stock Commercial Bank (HDBank)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
        ],
    },
    msb: {
        value: 'MSB',
        label: 'Vietnam Maritime Commercial Joint Stock Bank (MariTimeBan k)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.atmOffline.value,
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    nvb: {
        value: 'NVB',
        label: 'Nam Viet Bank (NaviBank)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    vab: {
        value: 'VAB',
        label: 'Vietnam Asia Commercial Joint Stock Bank (VietA Bank)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
        ],
    },
    vpb: {
        value: 'VPB',
        label: 'Vietnam Prosperity Bank (VPBank)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    stb: {
        value: 'STB',
        label: 'Saigon Thuong Tin Commercial Joint Stock Bank',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.atmOffline.value,
        ],
    },
    gpb: {
        value: 'GPB',
        label: 'Global Petro Commercial Joint Stock Bank(GPBank)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
        ],
    },
    agb: {
        value: 'AGB',
        label: 'Vietnam Bank For Agriculture and Rural Development (Agribank)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.atmOffline.value,
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    bidv: {
        value: 'BIDV',
        label: 'Bank for Investment & Dof Vietnam (BIDV)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.atmOffline.value,
            nganLuongPaymentMethods.ibOnline.value,
        ],
    },
    ojb: {
        value: 'OJB',
        label: 'OceanBank (OceanBank)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
        ],
    },
    pgb: {
        value: 'PGB',
        label: 'Petrolimex Group Commercial Joint Stock Bank',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.atmOffline.value,
        ],
    },
    shb: {
        value: 'SHB',
        label: 'Saigon Hanoi Commercial Joint Stock Bank (SHB)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.atmOffline.value,
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    tpb: {
        value: 'TPB',
        label: 'TienPhong Bank',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.ibOnline.value,
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    nab: {
        value: 'NAB',
        label: 'Nam A commercial joint stock bank',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
        ],
    },
    sgb: {
        value: 'SGB',
        label: 'Sai Gon Bank for Industry and Trade (Saigon Bank)',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    bab: {
        value: 'BAB',
        label: 'Bac A commercial joint stock bank',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
        ],
    },
    abb: {
        value: 'ABB',
        label: 'An Binh Commercial Joint Stock Bank',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    ocb: {
        value: 'OCB',
        label: 'Orient Commercial Joint Stock Bank',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    sea: {
        value: 'SEA',
        label: 'Southeast Asia Commercial Joint Stock Bank',
        methods: [
            nganLuongPaymentMethods.atmOnline.value,
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    sgcb: {
        value: 'SGCB',
        label: 'Saigon Commercial Bank',
        methods: [
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    ivb: {
        value: 'IVB',
        label: 'Indovina bank',
        methods: [
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    wcp: {
        value: 'WCP',
        label: 'WeChat Pay',
        methods: [
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
    gdb: {
        value: 'GDB',
        label: 'Viet Capital Commercial Joint Stock Bank',
        methods: [
            nganLuongPaymentMethods.qrCode.value,
        ],
    },
});
export const thunderxpayTransactionStatuses = generateKeys({
    pending: {
        value: 'W',
        label: 'Pending Verification',
    },
    approved: {
        value: 'AP',
        label: 'Approve Transaction',
    },
    rejected: {
        value: 'RJ',
        label: 'Transaction Rejected',
    },
});
export const thunderxpayWithdrawSubmitstatuses = generateKeys({
    success: {
        value: '00',
        label: 'Withdraw Success',
    },
    failed: {
        value: '01',
        label: 'Invalid Parameter',
    },
});
export const thunderxpayCurrencies = generateKeys({
    th: {
        value: 'THB',
        label: 'Thailand',
    },
    la: {
        value: 'LAK',
        label: 'Laos',
    },
    mm: {
        value: 'MMK',
        label: 'Myanmar',
    },
    za: {
        value: 'ZAR',
        label: 'South Africa',
    },
});
export const directa24TaxNumberLabels = generateKeys({
    br: {
        label: 'CPF/CNPJ',
        localization: { id: '', defaultMessage: '' },
        options: {
            cpf: {
                label: 'CPF',
                value: 'CPF',
                key: 'cpf',
            },
            cnpj: {
                label: 'CNPJ',
                value: 'CNPJ',
                key: 'cnpj',
            },
        },
    },
    ar: {
        label: 'DNI',
        localization: { id: '', defaultMessage: '' },
        options: {
            dni: {
                label: 'DNI',
                value: 'DNI',
                key: 'dni',
            },
        },
    },
    uy: {
        label: 'CI',
        localization: { id: '', defaultMessage: '' },
        options: {
            ci: {
                label: 'CI',
                value: 'CI',
                key: 'ci',
            },
        },
    },
    mx: {
        label: 'CURP/RFC/IFE/PASS/Residencia',
        localization: { id: '', defaultMessage: '' },
        options: {
            curp: {
                label: 'CURP',
                value: 'CURP',
                key: 'curp',
            },
            rfc: {
                label: 'RFC',
                value: 'RFC',
                key: 'rfc',
            },
            ife: {
                label: 'IFE',
                value: 'IFE',
                key: 'ife',
            },
            pass: {
                label: 'PASS',
                value: 'PASS',
                key: 'pass',
            },
            res: {
                label: 'Residencia',
                value: 'Residencia',
                key: 'res',
            },
        },
    },
    pe: {
        label: 'CE/DNI/PASS/RUC',
        localization: { id: '', defaultMessage: '' },
        options: {
            ce: {
                label: 'CE',
                value: 'CE',
                key: 'ce',
            },
            dni: {
                label: 'DNI',
                value: 'DNI',
                key: 'dni',
            },
            pass: {
                label: 'PASS',
                value: 'PASS',
                key: 'pass',
            },
            ruc: {
                label: 'RUC',
                value: 'RUC',
                key: 'ruc',
            },
        },
    },
    cl: {
        label: 'ID/RUN/RUT',
        localization: { id: '', defaultMessage: '' },
        options: {
            id: {
                label: 'ID',
                value: 'ID',
                key: 'id',
            },
            run: {
                label: 'RUN',
                value: 'RUN',
                key: 'run',
            },
            rut: {
                label: 'RUT',
                value: 'RUT',
                key: 'rut',
            },
        },
    },
    co: {
        label: 'CC/NIT/CE/PASS',
        localization: { id: '', defaultMessage: '' },
        options: {
            cc: {
                label: 'CC',
                value: 'CC',
                key: 'cc',
            },
            nit: {
                label: 'NIT',
                value: 'NIT',
                key: 'nit',
            },
            ce: {
                label: 'CE',
                value: 'CE',
                key: 'ce',
            },
            pass: {
                label: 'PASS',
                value: 'PASS',
                key: 'pass',
            },
        },
    },
    py: {
        label: 'CI',
        localization: { id: '', defaultMessage: '' },
        options: {
            ci: {
                label: 'CI',
                value: 'CI',
                key: 'ci',
            },
        },
    },
    pa: {
        label: 'CI',
        localization: { id: '', defaultMessage: '' },
        options: {
            ci: {
                label: 'CI',
                value: 'CI',
                key: 'ci',
            },
        },
    },
    ke: {
        label: 'ID',
        localization: { id: '', defaultMessage: '' },
        options: {
            id: {
                label: 'ID',
                value: 'ID',
                key: 'id',
            },
        },
    },
    ng: {
        label: 'ID',
        localization: { id: '', defaultMessage: '' },
        options: {
            id: {
                label: 'ID',
                value: 'ID',
                key: 'id',
            },
        },
    },
    id: {
        label: 'ID',
        localization: { id: '', defaultMessage: '' },
        options: {
            id: {
                label: 'ID',
                value: 'ID',
                key: 'id',
            },
        },
    },
    za: {
        label: 'ID',
        localization: { id: '', defaultMessage: '' },
        options: {
            id: {
                label: 'ID',
                value: 'ID',
                key: 'id',
            },
        },
    },
    tz: {
        label: 'ID',
        localization: { id: '', defaultMessage: '' },
        options: {
            id: {
                label: 'ID',
                value: 'ID',
                key: 'id',
            },
        },
    },
    gh: {
        label: 'ID',
        localization: { id: '', defaultMessage: '' },
        options: {
            id: {
                label: 'ID',
                value: 'ID',
                key: 'id',
            },
        },
    },
});
export const bridgerPayPaymentTypes = generateKeys({
    creditCard: {
        value: 'credit_card',
        label: 'Credit Card',
        acronym: 'CC',
        externalProcess: false,
        fundingCategory: fundingCategories.card.value,
    },
    qubePay: {
        value: 'qube_pay',
        label: 'Credit Card',
        acronym: 'CC',
        externalProcess: false,
        fundingCategory: fundingCategories.card.value,
    },
    paytrust: {
        value: 'pay_trust',
        label: 'PayTrust',
        acronym: 'PTR',
        externalProcess: true,
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    zotapay: {
        value: 'zota_pay',
        label: 'Zotapay',
        acronym: 'ZOT',
        externalProcess: false,
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    nganLuong: {
        value: 'ngan_luong',
        label: 'Ngan Luong',
        acronym: 'NLU',
        externalProcess: true,
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    help2Pay: {
        value: 'help2_pay',
        label: 'Help2Pay',
        acronym: 'H2P',
        externalProcess: true,
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    flutterwave: {
        value: 'flutterwave',
        label: 'Flutterwave',
        acronym: 'RAV',
        externalProcess: false,
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    astropay: {
        value: 'astro_pay',
        label: 'Astropay',
        acronym: 'AST',
        externalProcess: true,
        fundingCategory: fundingCategories.card.value,
    },
    directa24: {
        value: 'directa24',
        label: 'Directa24',
        acronym: 'DIR',
        externalProcess: true,
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    isignthis: {
        value: 'i_signthis',
        label: 'iSignthis',
        acronym: 'IST',
        externalProcess: false,
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    fasapay: {
        value: 'fasa_pay',
        label: 'Fasapay',
        acronym: 'FAS',
        externalProcess: true,
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    globepay: {
        value: 'globe_pay',
        label: 'Globepay',
        acronym: 'GLO',
        externalProcess: true,
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    payretailers: {
        value: 'payretailers',
        label: 'Payretailers',
        acronym: 'PRT',
        externalProcess: true,
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    gigadat: {
        value: 'gigadat',
        label: 'Gigadat',
        acronym: 'GIG',
        externalProcess: true,
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    emerchantpay: {
        value: 'emerchantpay',
        label: 'emerchantpay',
        acronym: 'EMP',
        externalProcess: false,
        fundingCategory: fundingCategories.onlineBanking.value,
    },
});
export const directa24CountryCurrencyMap = generateKeys({
    ar: {
        value: 'ARS',
        label: 'Argentina',
    },
    br: {
        value: 'BRL',
        label: 'Brazil',
    },
    cl: {
        value: 'CLP',
        label: 'Chile',
    },
    cn: {
        value: 'CNY',
        label: 'China',
    },
    co: {
        value: 'COP',
        label: 'Colombia',
    },
    mx: {
        value: 'MXN',
        label: 'Mexico',
    },
    pa: {
        value: 'USD',
        label: 'Panama',
    },
    pe: {
        value: 'PEN',
        label: 'Peru',
    },
    py: {
        value: 'PYG',
        label: 'Paraguay',
    },
    uy: {
        value: 'UYU',
        label: 'Uruguay',
    },
    gh: {
        value: 'GHS',
        label: 'Ghana',
    },
    in: {
        value: 'INR',
        label: 'India',
    },
    ke: {
        value: 'KES',
        label: 'Kenya',
    },
    ng: {
        value: 'NGN',
        label: 'Nigeria',
    },
    za: {
        value: 'ZAR',
        label: 'South Africa',
    },
    tz: {
        value: 'TZS',
        label: 'Tanzania',
    },
    ug: {
        value: 'UGX',
        label: 'Uganda',
    },
});
export const cardpayPaymentTypes = generateKeys({
    creditCard: {
        value: 'BANKCARD',
        label: 'Credit Card',
        fundingCategory: fundingCategories.card.value,
    },
    directBanking: {
        value: 'DIRECTBANKINGEU',
        label: 'Direct Banking Europe',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    qiwi: {
        value: 'QIWI',
        label: 'Qiwi',
        fundingCategory: fundingCategories.onlineBanking.value,
        excludeFromBankTransfer: true,
    },
    yandex: {
        value: 'YANDEXMONEY',
        label: 'Yandex.Money',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    rapiPago: {
        value: 'RAPIPAGO',
        label: 'Rapi Pago',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    boleto: {
        value: 'BOLETO',
        label: 'Boleto',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bradesco: {
        value: 'BRADESCO',
        label: 'Bradesco',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoDoBrasil: {
        value: 'BANCODOBRASIL',
        label: 'Banco do Brasil',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    caixa: {
        value: 'CAIXA',
        label: 'Caixa',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    depositExpressBrazil: {
        value: 'DEPOSITEXPRESSBRL',
        label: 'Deposit Express Brasil',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    loterica: {
        value: 'LOTERICA',
        label: 'Loterica',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    santander: {
        value: 'SANTANDER',
        label: 'santander',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    webpay: {
        value: 'WEBPAY',
        label: 'WebPay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoDeChile: {
        value: 'BANCODECHILE',
        label: 'Banco de Chile',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    servipag: {
        value: 'SERVIPAG',
        label: 'Servipag',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    itau: {
        value: 'ITAU',
        label: 'ITAU',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    corpbanca: {
        value: 'CORPBANCA',
        label: 'Corpbanca',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bciTbanc: {
        value: 'BCITBANC',
        label: 'BCI-TBANC',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoFalabella: {
        value: 'BANCOFALABELLA',
        label: 'Banco Falabella',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoEstado: {
        value: 'BANCOESTADO',
        label: 'Banco Estado',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoBice: {
        value: 'BANCOBICE',
        label: 'Banco Bice',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoSecurity: {
        value: 'BANCOSECURITY',
        label: 'Banco Security',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoConsorcio: {
        value: 'BANCOCONSORCIO',
        label: 'Banco Consorcio',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoRipley: {
        value: 'BANCORIPLEY',
        label: 'Banco Ripley',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    scotiaBank: {
        value: 'SCOTIABANK',
        label: 'Scotia Bank',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    coopeuch: {
        value: 'COOPEUCH',
        label: 'Coopeuch',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    efecty: {
        value: 'EFECTY',
        label: 'Efecty',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    davivienda: {
        value: 'DAVIVIENDA',
        label: 'Davivienta',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    daviviendaBank: {
        value: 'DAVIVIENDABANK',
        label: 'Davivienta Bank',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    pse: {
        value: 'PSE',
        label: 'PSE',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    aexito: {
        value: 'AEXITO',
        label: 'Almacenes Exito',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    baloto: {
        value: 'BALOTO',
        label: 'Baloto',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    carulla: {
        value: 'CARULLA',
        label: 'Carulla',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    edeq: {
        value: 'EDEQ',
        label: 'Empresa de Energí a del Quindio',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    surtimax: {
        value: 'SURTIMAX',
        label: 'Surtimax',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    boletoBancolombia: {
        value: 'BOLETOBANCOLOMBIA',
        label: 'Boleto Bancolombia',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoAvVillas: {
        value: 'BANCOAVVILLAS',
        label: 'Banco Av Villas',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoCajaSocial: {
        value: 'BANCOCAJASOCIAL',
        label: 'Banco Caja Social',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoColpatria: {
        value: 'BANCOCOLPATRIA',
        label: 'Banco Colpatria',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoDeBogota: {
        value: 'BANCODEBOGOTA',
        label: 'Banco de Bogota',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoDeOccidente: {
        value: 'BANCODEOCCIDENTE',
        label: 'Banco de Occidente',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    gnb: {
        value: 'BANCOGNBSUDAMERIS',
        label: 'Banco GNB Sudameris',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoPichincha: {
        value: 'BANCOPICHINCHASA',
        label: 'Banco Pichincha S.A.',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoPopular: {
        value: 'BANCOPOPULAR',
        label: 'Banco Popular',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoProcredit: {
        value: 'BANCOPROCREDIT',
        label: 'Banco Procredit',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancolombia: {
        value: 'BANCOLOMBIA',
        label: 'Bancolombia',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoomevaSa: {
        value: 'BANCOOMEVASA',
        label: 'Bancoomeva S.A.',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bbvaColombia: {
        value: 'BBVACOLOMBIASA',
        label: 'BBVA Colombia S.A.',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    oxxo: {
        value: 'OXXO',
        label: 'OXXO',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    spei: {
        value: 'SPEI',
        label: 'SPEI',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bbvaBancomer: {
        value: 'BBVABANCOMER',
        label: 'BBVA Bancomer',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    banamex: {
        value: 'BANAMEX',
        label: 'Banamex',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    paynet: {
        value: 'PAYNET',
        label: 'Paynet',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    pagoEfectivo: {
        value: 'PAGOEFECTIVO',
        label: 'Pago Efectivo',
        fundingCategory: fundingCategories.onlineBanking.value,
        requiresCustomerId: true,
    },
    bcp: {
        value: 'BCP',
        label: 'BCP',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    interbank: {
        value: 'INTERBANK',
        label: 'Interbank',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bbva: {
        value: 'BBVA',
        label: 'BBVA',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    redPagos: {
        value: 'REDPAGOS',
        label: 'Red Pagos',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoAgrario: {
        value: 'BANCOAGRARIO',
        label: 'Banco Agrario',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bancoCorpbanca: {
        value: 'BANCOCORPBANCASA',
        label: 'Banco Corpbanca S.A.',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    citiBank: {
        value: 'CITIBANK',
        label: 'Citi Bank',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    helmBank: {
        value: 'HELMBANKSA',
        label: 'Helm Bank S.A.',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    pagoFacil: {
        value: 'PAGOFACIL',
        label: 'Pago Facil',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    santanderRio: {
        value: 'SANTANDERRIO',
        label: 'Santander Rio',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    alipay: {
        value: 'ALIPAY',
        label: 'Alipay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bitcoin: {
        value: 'BITCOIN',
        label: 'Bitcoin',
        fundingCategory: fundingCategories.crypto.value,
    },
    onlinePay: {
        value: 'ONLINEPAY',
        label: 'Online Pay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    webMoney: {
        value: 'WEBMONEY',
        label: 'WebMoney',
        fundingCategory: fundingCategories.onlineBanking.value,
        excludeFromBankTransfer: true,
    },
    payPal: {
        value: 'PAYPAL',
        label: 'PayPal',
        fundingCategory: fundingCategories.eWallet.value,
    },
    applePay: {
        value: 'APPLEPAY',
        label: 'ApplePay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    directBankingNigeria: {
        value: 'DIRECTBANKINGNGA',
        label: 'Direct Banking Nigeria',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    qrCode: {
        value: 'AQRCODE',
        label: 'QR code',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    mPesa: {
        value: 'MPESA',
        label: 'M-Pesa',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    mtn: {
        value: 'MTN',
        label: 'MTN',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    ugandaMobileMoney: {
        value: 'UGANDAMOBILE',
        label: 'Uganda Mobile Money',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    vodafone: {
        value: 'VODAFONE',
        label: 'Vodafone',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    tigo: {
        value: 'TIGO',
        label: 'Tigo',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    airtel: {
        value: 'AIRTEL',
        label: 'Airtel',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    alfaVa: {
        value: 'ALFAVA',
        label: 'Alfa VA',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    cimbVa: {
        value: 'CIMBVA',
        label: 'CIMB VA',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    danamonVa: {
        value: 'DANAMONVA',
        label: 'Danamon VA',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    permataVa: {
        value: 'PERMATAVA',
        label: 'Parmata VA',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    mandiriVa: {
        value: 'MANDIRIVA',
        label: 'Mandiri VA',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    permataIb: {
        value: 'PERMATAIB',
        label: 'Permata Internet Banking',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    dokuWallet: {
        value: 'DOKUWALLET',
        label: 'DOKU Wallet',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    usdtether: {
        value: 'USDTETHER',
        label: 'USDTETHER',
        fundingCategory: fundingCategories.crypto.value,
    },
    pix: {
        value: 'PIX',
        label: 'Pix',
        fundingCategory: fundingCategories.onlineBanking.value,
        requiresCustomerId: true,
        excludeFromBankTransfer: true,
    },
    picpay: {
        value: 'PICPAY',
        label: 'PicPay',
        fundingCategory: fundingCategories.onlineBanking.value,
        requiresCustomerId: true,
    },
    qrcode3166: {
        value: 'QRCODE3166',
        label: 'QR code 3166',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
});
export const transact365Types = generateKeys({
    bankpay: {
        value: 'BANKPAY',
        label: 'Bank Pay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    qr: {
        value: 'QR',
        label: 'QR',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    unionpay: {
        value: 'UNIONPAY',
        label: 'UnionPay QR',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    p2p: {
        value: 'P2P',
        label: 'P2P',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
});
export const cardpayDocumentTypes = generateKeys({
    DNI_PE: {
        value: 'DNI',
        label: 'National identity document',
        country: countries.pe,
    },
    PAR_PE: {
        value: 'PAR',
        label: 'Partida',
        country: countries.pe,
    },
    PAS_PE: {
        value: 'PAS',
        label: 'Passport',
        country: countries.pe,
    },
    LMI_PE: {
        value: 'LMI',
        label: 'Libreta militar',
        country: countries.pe,
    },
    NAN_PE: {
        value: 'NAN',
        label: 'Other',
        country: countries.pe,
    },
    PAS_EC: {
        value: 'PAS',
        label: 'Passport',
        country: countries.ec,
    },
    NAN_EC: {
        value: 'NAN',
        label: 'Other',
        country: countries.ec,
    },
});
export const easyEftBanks = generateKeys({
    absa: {
        label: 'ABSA',
        value: 'absa',
        country: countries.za,
    },
    standard: {
        label: 'Standard Bank',
        value: 'standard',
        country: countries.za,
    },
    fnb: {
        label: 'First Bank',
        value: 'fnb',
        country: countries.za,
    },
    nedbank: {
        label: 'Nedbank',
        value: 'nedbank',
        country: countries.za,
    },
    capitec: {
        label: 'Capitec',
        value: 'capitec',
        country: countries.za,
    },
    investec: {
        label: 'Investec',
        value: 'investec',
        country: countries.za,
    },
    tyme: {
        label: 'Tyme Bank',
        value: 'tyme',
        country: countries.za,
    },
    afribank: {
        label: 'African Bank',
        value: 'afribank',
        country: countries.za,
    },
    bidvest: {
        label: 'Bidvest Bank',
        value: 'bidvest',
        country: countries.za,
    },
    oldmutual: {
        label: 'Old Mutual Bank',
        value: 'oldmutual',
        country: countries.za,
    },
});
export const dotpayBanks = generateKeys({
    mbank: {
        label: 'mBank',
        value: 'mbank',
        country: countries.pl,
    },
    citi_handlowy: {
        label: 'Citi handlowy',
        value: 'citi_handlowy',
        country: countries.pl,
    },
    blink: {
        label: 'Blink',
        value: 'blink',
        country: countries.pl,
    },
    santander: {
        label: 'Santander Przelew24',
        value: 'santander',
        country: countries.pl,
    },
    pekao: {
        label: 'Bank Pekao',
        value: 'pekao',
        country: countries.pl,
    },
    alior: {
        label: 'Alior Bank',
        value: 'alior',
        country: countries.pl,
    },
    millennium: {
        label: 'Millennium Bank',
        value: 'millennium',
        country: countries.pl,
    },
    bank_bps: {
        label: 'Bank BPS',
        value: 'bank_bps',
        country: countries.pl,
    },
    toyota: {
        label: 'Toyota Bank',
        value: 'toyota',
        country: countries.pl,
    },
    noble: {
        label: 'Noble Bank',
        value: 'noble',
        country: countries.pl,
    },
    bos: {
        label: 'BOS Bank',
        value: 'bos',
        country: countries.pl,
    },
    plus: {
        label: 'Plus Bank',
        value: 'plus',
        country: countries.pl,
    },
    envelo: {
        label: 'Envelo Bank',
        value: 'envelo',
        country: countries.pl,
    },
    getin: {
        label: 'Get In Bank',
        value: 'getin',
        country: countries.pl,
    },
    nowy: {
        label: 'Bank Nowy BFG S. A.',
        value: 'nowy',
        country: countries.pl,
    },
    tmobile: {
        label: 'T-Mobile Usługi Bankowe',
        value: 'tmobile',
        country: countries.pl,
    },
    idea: {
        label: 'Idea Bank',
        value: 'idea',
        country: countries.pl,
    },
    ipko: {
        label: 'Płacę z iPKO',
        value: 'ipko',
        country: countries.pl,
    },
    pocztowy24: {
        label: 'Pocztowy24',
        value: 'pocztowy24',
        country: countries.pl,
    },
    ing: {
        label: 'Płacę z ING',
        value: 'ing',
        country: countries.pl,
    },
    paribas: {
        label: 'BNP Paribas',
        value: 'paribas',
        country: countries.pl,
    },
    inteligo: {
        label: 'Płacę z Inteligo',
        value: 'inteligo',
        country: countries.pl,
    },
});
export const payretailersBanks = generateKeys({
    bankoBrazil: {
        value: 'bankoBrazil',
        label: 'Banco do Brasil',
        country: countries.br,
    },
    bradesco: {
        value: 'bradesco',
        label: 'Bradesco',
        country: countries.br,
    },
    itau: {
        value: 'itau',
        label: 'Itaú',
        country: countries.br,
    },
    bancoEstado: {
        value: 'bancoEstado',
        label: 'Banco Estado',
        country: countries.cl,
    },
    sanatnder: {
        value: 'sanatnder',
        label: 'Sanatnder',
        country: countries.cl,
    },
    webPay: {
        value: 'webPay',
        label: 'WebPay',
        country: countries.cl,
    },
    bCI: {
        value: 'bCI',
        label: 'BCI',
        country: countries.cl,
    },
    tBanc: {
        value: 'tBanc',
        label: 'TBanc',
        country: countries.cl,
    },
    bBVA: {
        value: 'bBVA',
        label: 'BBVA',
        country: countries.co,
    },
    citibank: {
        value: 'citibank',
        label: 'Citibank',
        country: countries.co,
    },
    bancoPichinchaCo: {
        value: 'bancoPichinchaCo',
        label: 'Banco Pichincha',
        country: countries.co,
    },
    itaú: {
        value: 'itaú',
        label: 'Itaú',
        country: countries.co,
    },
    nequi: {
        value: 'nequi',
        label: 'Nequi',
        country: countries.co,
    },
    daviplata: {
        value: 'daviplata',
        label: 'Daviplata',
        country: countries.co,
    },
    confiarCorp: {
        value: 'confiarCorp',
        label: 'Confiar Corp',
        country: countries.co,
    },
    bancoAVVillas: {
        value: 'bancoAVVillas',
        label: 'Banco AV Villas',
        country: countries.co,
    },
    bancoCajaSocial: {
        value: 'bancoCajaSocial',
        label: 'Banco Caja Social',
        country: countries.co,
    },
    scotiabankColpatria: {
        value: 'scotiabankColpatria',
        label: 'Scotiabank Colpatria',
        country: countries.co,
    },
    bancoCooperativoCoopCentral: {
        value: 'bancoCooperativoCoopCentral',
        label: 'Banco Cooperativo Coop Central',
        country: countries.co,
    },
    bancoBogota: {
        value: 'bancoBogota',
        label: 'Banco Bogota',
        country: countries.co,
    },
    bancoOccidenteCredencial: {
        value: 'bancoOccidenteCredencial',
        label: 'Banco Occidente Credencial',
        country: countries.co,
    },
    bancoFalabella: {
        value: 'bancoFalabella',
        label: 'Banco Falabella',
        country: countries.co,
    },
    bancoGNBSudameris: {
        value: 'bancoGNBSudameris',
        label: 'Banco GNB Sudameris',
        country: countries.co,
    },
    bancoPopular: {
        value: 'bancoPopular',
        label: 'Banco Popular',
        country: countries.co,
    },
    proCreditBank: {
        value: 'proCreditBank',
        label: 'ProCredit Bank',
        country: countries.co,
    },
    bancolombia: {
        value: 'bancolombia',
        label: 'Bancolombia',
        country: countries.co,
    },
    bancoomeva: {
        value: 'bancoomeva',
        label: 'Bancoomeva',
        country: countries.co,
    },
    bancoAgrariodeColombia: {
        value: 'bancoAgrariodeColombia',
        label: 'Banco Agrario de Colombia',
        country: countries.co,
    },
    banorte: {
        value: 'banorte',
        label: 'Banorte',
        country: countries.mx,
    },
    santander: {
        value: 'santander',
        label: 'Santander',
        country: countries.mx,
    },
    scotiabankMx: {
        value: 'scotiabankMx',
        label: 'Scotiabank',
        country: countries.mx,
    },
    bBVABancomer: {
        value: 'bBVABancomer',
        label: 'BBVA Bancomer',
        country: countries.mx,
    },
    bCP: {
        value: 'bCP',
        label: 'BCP',
        country: countries.pe,
    },
    bBVApe: {
        value: 'bBVApe',
        label: 'BBVA',
        country: countries.pe,
    },
    interbank: {
        value: 'interbank',
        label: 'Interbank',
        country: countries.pe,
    },
    scotiabankPe: {
        value: 'scotiabankPe',
        label: 'Scotiabank',
        country: countries.pe,
    },
    cajaTacna: {
        value: 'cajaTacna',
        label: 'Caja Tacna',
        country: countries.pe,
    },
    cajaTrujillo: {
        value: 'cajaTrujillo',
        label: 'Caja Trujillo',
        country: countries.pe,
    },
    cajaHuancayo: {
        value: 'cajaHuancayo',
        label: 'Caja Huancayo',
        country: countries.pe,
    },
    cajaArequipa: {
        value: 'cajaArequipa',
        label: 'Caja Arequipa',
        country: countries.pe,
    },
    bancoCathay: {
        value: 'bancoCathay',
        label: 'Banco Cathay',
        country: countries.cr,
    },
    bancoNaciona: {
        value: 'bancoNaciona',
        label: 'Banco Naciona',
        country: countries.cr,
    },
    grupoMutual: {
        value: 'grupoMutual',
        label: 'Grupo Mutual',
        country: countries.cr,
    },
    mucap: {
        value: 'mucap',
        label: 'Mucap',
        country: countries.cr,
    },
    bancoGuayaquil: {
        value: 'bancoGuayaquil',
        label: 'Banco Guayaquil',
        country: countries.ec,
    },
    bancoPichinchaEs: {
        value: 'bancoPichinchaEs',
        label: 'Banco Pichincha',
        country: countries.ec,
    },
});
export const dusupayPaymentTypes = generateKeys({
    mobileMoney: {
        value: 'MOBILE_MONEY',
        label: 'Mobile Money',
        fundingCategory: fundingCategories.onlineBanking.value,
        countries: [
            countries.ug.value,
            countries.ke.value,
            countries.rw.value,
            countries.bi.value,
            countries.gh.value,
            countries.cm.value,
            countries.zm.value,
            countries.ci.value,
            countries.sn.value,
            countries.tz.value,
        ],
        types: [
            'collection',
            'payout',
        ],
    },
    card: {
        value: 'CARD',
        label: 'Card',
        fundingCategory: fundingCategories.card.value,
        countries: [
            countries.ug.value,
            countries.ke.value,
            countries.gh.value,
            countries.ng.value,
        ],
        types: [
            'collection',
        ],
    },
    bank: {
        value: 'BANK',
        label: 'Bank',
        fundingCategory: fundingCategories.onlineBanking.value,
        countries: [
            countries.ug.value,
            countries.ke.value,
            countries.gh.value,
            countries.za.value,
            countries.ng.value,
            countries.ci.value,
        ],
        types: [
            'payout',
        ],
    },
});
export const rpnpayBanks = generateKeys({
    industrialandCommercialBankofChina: {
        value: 'industrialandCommercialBankofChina',
        label: 'Industrial and Commercial Bank of China',
        country: countries.cn,
    },
    agricultureBankofChina: {
        value: 'agricultureBankofChina',
        label: 'Agriculture Bank of China',
        country: countries.cn,
    },
    bankofChina: {
        value: 'bankofChina',
        label: 'Bank of China',
        country: countries.cn,
    },
    chinaConstructionBank: {
        value: 'chinaConstructionBank',
        label: 'China Construction Bank',
        country: countries.cn,
    },
    bankofCommunications: {
        value: 'bankofCommunications',
        label: 'Bank of Communications',
        country: countries.cn,
    },
    chianEverbrightBank: {
        value: 'chianEverbrightBank',
        label: 'Chian Everbright Bank',
        country: countries.cn,
    },
    shanghaiPudongDevelopmentBank: {
        value: 'shanghaiPudongDevelopmentBank',
        label: 'Shanghai Pudong Development Bank',
        country: countries.cn,
    },
    bankofBeijing: {
        value: 'bankofBeijing',
        label: 'Bank of Beijing',
        country: countries.cn,
    },
    guangdongDevelopmentBank: {
        value: 'guangdongDevelopmentBank',
        label: 'Guangdong Development Bank',
        country: countries.cn,
    },
    pingAnBank: {
        value: 'pingAnBank',
        label: 'Ping An Bank',
        country: countries.cn,
    },
    chinaIndustrialBank: {
        value: 'chinaIndustrialBank',
        label: 'China Industrial Bank',
        country: countries.cn,
    },
    chinaMerchantsBank: {
        value: 'chinaMerchantsBank',
        label: 'China Merchants Bank',
        country: countries.cn,
    },
    shenzhenDevelopmentBank: {
        value: 'shenzhenDevelopmentBank',
        label: 'Shenzhen Development Bank',
        country: countries.cn,
    },
    postalSavingsBankofChina: {
        value: 'postalSavingsBankofChina',
        label: 'Postal Savings Bank of China',
        country: countries.cn,
    },
    huaxiaBank: {
        value: 'huaxiaBank',
        label: 'Huaxia Bank',
        country: countries.cn,
    },
    chinaMinshengBank: {
        value: 'chinaMinshengBank',
        label: 'China Minsheng Bank',
        country: countries.cn,
    },
    cITIC: {
        value: 'cITIC',
        label: 'CITIC',
        country: countries.cn,
    },
    bankofHangzhou: {
        value: 'bankofHangzhou',
        label: 'Bank of Hangzhou',
        country: countries.cn,
    },
    unionpay: {
        value: 'unionpay',
        label: 'Unionpay',
        country: countries.cn,
    },
});
export const flutterwaveBanks = generateKeys({
    unitedbankofAfrica: {
        value: 'unitedbankofAfrica',
        label: 'United bank of Africa',
        country: countries.ng,
    },
    firstBank: {
        value: 'firstBank',
        label: 'First Bank',
        country: countries.ng,
    },
    gTBank: {
        value: 'gTBank',
        label: 'GTBank',
        country: countries.ng,
    },
    sterling: {
        value: 'sterling',
        label: 'Sterling ',
        country: countries.ng,
    },
    zenith: {
        value: 'zenith',
        label: 'Zenith',
        country: countries.ng,
    },
    unityBankplc: {
        value: 'unityBankplc',
        label: 'Unity Bank plc',
        country: countries.ng,
    },
    providusBank: {
        value: 'providusBank',
        label: 'Providus Bank',
        country: countries.ng,
    },
    accessBank: {
        value: 'accessBank',
        label: 'Access Bank',
        country: countries.ng,
    },
    fidelityBank: {
        value: 'fidelityBank',
        label: 'Fidelity Bank',
        country: countries.ng,
    },
    firstCityMonumentBank: {
        value: 'firstCityMonumentBank',
        label: 'First City Monument Bank',
        country: countries.ng,
    },
    guarantyTrustBank: {
        value: 'guarantyTrustBank',
        label: 'Guaranty Trust Bank',
        country: countries.ng,
    },
    unionBankofNigeria: {
        value: 'unionBankofNigeria',
        label: 'Union Bank of Nigeria',
        country: countries.ng,
    },
});
export const dragonpayBanks = generateKeys({
    asiaUnitedBank: {
        value: 'asiaUnitedBank',
        label: 'Asia United Bank',
        country: countries.ph,
    },
    bancodeOro: {
        value: 'bancodeOro',
        label: 'Banco de Oro (BDO)',
        country: countries.ph,
    },
    bPIDirectSavingsBank: {
        value: 'bPIDirectSavingsBank',
        label: 'BPI Direct Savings Bank',
        country: countries.ph,
    },
    eastWestBank: {
        value: 'eastWestBank',
        label: 'EastWest Bank',
        country: countries.ph,
    },
    chinaBank: {
        value: 'chinaBank',
        label: 'China Bank',
        country: countries.ph,
    },
    landbank: {
        value: 'landbank',
        label: 'Landbank',
        country: countries.ph,
    },
    metrobank: {
        value: 'metrobank',
        label: 'Metrobank',
        country: countries.ph,
    },
    pNB: {
        value: 'pNB',
        label: 'PNB (Philippine National Bank)',
        country: countries.ph,
    },
    philippineSavingBank: {
        value: 'philippineSavingBank',
        label: 'Philippine Saving Bank',
        country: countries.ph,
    },
    rCBCBank: {
        value: 'rCBCBank',
        label: 'RCBC Bank',
        country: countries.ph,
    },
    robinsonsBank: {
        value: 'robinsonsBank',
        label: 'Robinsons Bank',
        country: countries.ph,
    },
    securityBankPhilippines: {
        value: 'securityBankPhilippines',
        label: 'Security Bank Philippines',
        country: countries.ph,
    },
    unitedCoconutPlantersBank: {
        value: 'unitedCoconutPlantersBank',
        label: 'United Coconut Planters Bank',
        country: countries.ph,
    },
    unionBank: {
        value: 'unionBank',
        label: 'Union Bank',
        country: countries.ph,
    },
});
export const powercash21PaymentTypes = generateKeys({
    creditCard: {
        value: '1',
        label: 'Credit Card',
        fundingCategory: fundingCategories.card.value,
    },
    ppro: {
        value: '5',
        label: 'Ppro',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    amex: {
        value: '11',
        label: 'Amex',
        fundingCategory: fundingCategories.card.value,
    },
    bankTransfer: {
        value: '17',
        label: 'Bank Transfer',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bitcoin: {
        value: '18',
        label: 'Bitcoin',
        fundingCategory: fundingCategories.crypto.value,
    },
    platincoin: {
        value: '20',
        label: 'Platincoin',
        fundingCategory: fundingCategories.crypto.value,
    },
    trustly: {
        value: '116',
        label: 'Trustly',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    directpay: {
        value: 'directpay',
        label: 'Directpay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    direct24: {
        value: 'direct24',
        label: 'Direct24',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    giropay: {
        value: 'giropay',
        label: 'Giropay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    eps: {
        value: 'eps',
        label: 'EPS',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    safetypay: {
        value: 'safetypay',
        label: 'Safetypay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    ideal: {
        value: 'ideal',
        label: 'iDeal',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    paysafecard: {
        value: 'paysafecard',
        label: 'Paysafecard',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    p24: {
        value: 'p24',
        label: 'P24',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    sepadirect: {
        value: 'sepadirect',
        label: 'SEPA Direct Debit',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    astropaydirect: {
        value: 'astropaydirect',
        label: 'Astropay Direct',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    astropaycard: {
        value: 'astropaycard',
        label: 'Astropay Card',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    boleto: {
        value: 'boleto',
        label: 'Boleto',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    entercash: {
        value: 'entercash',
        label: 'Entercash',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    bcmc: {
        value: 'bcmc',
        label: 'Bancontact',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    zimpler: {
        value: 'zimpler',
        label: 'Zimpler(Puggelpay)',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    wechatpay: {
        value: 'wechatpay',
        label: 'WeChat Pay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    alipay: {
        value: 'alipay',
        label: 'Alipay',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
});
export const paymentOptionStatuses = generateKeys({
    active: {
        label: 'Active',
        value: 'active',
        description: 'Payment option is live and enabled to clients',
    },
    disabled: {
        label: 'Disabled',
        value: 'disabled',
        description: 'Payment option is live but disabled to clients',
    },
    terminated: {
        label: 'Terminated',
        value: 'terminated',
        description: 'Payment option is offline and will no longer be used',
    },
});
export const paymentOptionMethods = generateKeys({
    depositOnly: {
        label: 'Deposit Only',
        value: 'depositOnly',
    },
    withdrawalOnly: {
        label: 'Withdrawal Only',
        value: 'withdrawalOnly',
    },
    initialDepositOnly: {
        label: 'Deposit and Withdrawal Initial Deposit Only',
        value: 'initialDepositOnly',
    },
    initialDepositProfits: {
        label: 'Deposit and Withdrawal Initial Deposit and Profits',
        value: 'initialDepositProfits',
    },
});
export const cardTypes = generateKeys({
    visa: {
        value: 'visa',
        label: 'Visa',
    },
    mastercard: {
        value: 'mastercard',
        label: 'Mastercard',
    },
    americanExpress: {
        value: 'americanExpress',
        label: 'American express',
    },
    discover: {
        value: 'discover',
        label: 'Discover',
    },
    dankort: {
        value: 'dankort',
        label: 'Dankort',
    },
});
export const rpnpayUsdtOptions = generateKeys({
    erc: {
        value: 'erc',
        label: 'ERC',
    },
    trc: {
        value: 'trc',
        label: 'TRC',
    },
});
export const paymentBankTransferInfo = {
    jmFinancial: {
        info: {
            recipient: 'JM Financial Brokerage Service Co.',
            iban: 'KW62 GULB0 0000 0000 0000 0935 27736',
            swift: 'GULBKWKW',
            bank: 'Gulf Bank',
            address: 'Head office Branch, Kuwait City',
            city: 'Kuwait City',
            country: 'Kuwait',
            currency: 'USD',
            creditingAccount: '93527736',
        },
    },
};
export const jmFinancialPaymentTypes = generateKeys({
    creditCard: {
        value: 'creditCard',
        label: 'JM Financial',
        fundingCategory: fundingCategories.card.value,
    },
    jmFinancialWireTransfer: {
        value: 'jmFinancialWireTransfer',
        label: 'JM Financial Wire Transfer',
        fundingCategory: fundingCategories.bankWire.value,
    },
});
export const exactlyPaymentTypes = generateKeys({
    creditCard: {
        value: 'card',
        label: 'Exactly Credit Card',
        fundingCategory: fundingCategories.card.value,
    },
    bkbIpay: {
        value: 'bkb_ipay',
        label: 'Bangkok Bank',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    scbEasypay: {
        value: 'scb_easypay',
        label: 'SCB Easy',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    crossBankQr: {
        value: 'cross_bank_qr',
        label: 'Exactly Cross Bank QR',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
});
export const easypayPaymentTypes = generateKeys({
    online: {
        value: 'online',
        label: 'Online',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    offline: {
        value: 'offline',
        label: 'Offline',
        fundingCategory: fundingCategories.bankWire.value,
    },
});
export const ubiqpayPaymentTypes = generateKeys({
    bank: {
        value: 'BANK',
        label: 'BANK',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    mobileMoney: {
        value: 'MOBILE_MONEY',
        label: 'Mobile Money',
        fundingCategory: fundingCategories.onlineDeposit.value,
    },
});
export const letknowpayCryptoCurrencies = generateKeys({
    BTC: {
        value: 'BTC',
        label: 'BTC',
    },
    ETH: {
        value: 'ETH',
        label: 'ETH',
    },
    XRP: {
        value: 'XRP',
        label: 'XRP',
    },
    USDT: {
        value: 'USDT',
        label: 'USDT (ERC20)',
    },
    USDTTRC20: {
        value: 'USDTTRC20',
        label: 'USDT (TRC20)',
    },
    BCH: {
        value: 'BCH',
        label: 'BCH',
    },
    LTC: {
        value: 'LTC',
        label: 'LTC',
    },
    DASH: {
        value: 'DASH',
        label: 'DASH',
    },
    ADA: {
        value: 'ADA',
        label: 'ADA',
    },
    ZEC: {
        value: 'ZEC',
        label: 'ZEC',
    },
    TUSD: {
        value: 'TUSD',
        label: 'TUSD',
    },
    USDC: {
        value: 'USDC',
        label: 'USDC (ERC20)',
    },
    PAX: {
        value: 'PAX',
        label: 'PAX',
    },
});
export const chipPayNetworks = generateKeys({
    BTC: {
        value: 'BTC',
        label: 'BTC',
    },
    ETH: {
        value: 'ETH',
        label: 'ETH',
    },
    ERC20: {
        value: 'ERC20',
        label: 'ERC20',
    },
    TRC20: {
        value: 'TRC20',
        label: 'TRC20',
    },
});
export const chipPayCryptoCurrencies = generateKeys({
    BTC: {
        value: 'BTC',
        label: 'BTC',
        networks: [chipPayNetworks.BTC],
    },
    ETH: {
        value: 'ETH',
        label: 'ETH',
        networks: [chipPayNetworks.ETH],
    },
    USDT: {
        value: 'USDT',
        label: 'USDT',
        networks: [
            chipPayNetworks.ERC20,
            chipPayNetworks.TRC20,
        ],
    },
});
export const beetellerPaymentTypes = generateKeys({
    banktransfer: {
        value: 'EFT',
        label: 'Bank Transfer',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    cash: {
        value: 'CASH',
        label: 'Cash',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    pix: {
        value: 'PIX',
        label: 'Pix',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
});
export const wallettecPaymentTypes = generateKeys({
    bank: {
        value: 'BANK',
        label: 'BANK',
        fundingCategory: fundingCategories.onlineBanking.value,
    },
    mobileMoney: {
        value: 'MOBILE_MONEY',
        label: 'Mobile Money',
        fundingCategory: fundingCategories.onlineDeposit.value,
    },
});
export const speedlightpayCryptoCurrencies = generateKeys({
    BTC: {
        value: 'BTC',
        label: 'BTC',
    },
    ETH: {
        value: 'ETH',
        label: 'ETH',
    },
    XRP: {
        value: 'XRP',
        label: 'XRP',
    },
    USDT: {
        value: 'USDT',
        label: 'USDT (ERC20)',
    },
    USDTTRC20: {
        value: 'USDTTRC20',
        label: 'USDT (TRC20)',
    },
    USDC: {
        value: 'USDC',
        label: 'USDC (ERC20)',
    },
    PAX: {
        value: 'PAX',
        label: 'PAX',
    },
    BCH: {
        value: 'BCH',
        label: 'BCH',
    },
    LTC: {
        value: 'LTC',
        label: 'LTC',
    },
    DASH: {
        value: 'DASH',
        label: 'DASH',
    },
    ZEC: {
        value: 'ZEC',
        label: 'ZEC',
    },
});
export const speedlightpayPartnerCryptoCurrencies = generateKeys({
    BTC: {
        value: 'BTC',
        label: 'BTC',
    },
    ETH: {
        value: 'ETH',
        label: 'ETH',
    },
    USDT: {
        value: 'USDT',
        label: 'USDT',
    },
    USDTTRC20: {
        value: 'USDTTRC20',
        label: 'USDT (TRC20)',
    },
    USDC: {
        value: 'USDC',
        label: 'USDC',
    },
    BCH: {
        value: 'BCH',
        label: 'BCH',
    },
});
